import React, { FC } from "react";

interface ReviewTabsProps {
  activeTab: number;
  setActiveTab: any;
}

const reviewTabList: string[] = ["Policyholder Details", "Insured Details", "Nominee Details"];

const ReviewTabs: FC<ReviewTabsProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="relative w-full px-0 md:px-10 py-0 md:py-5">
      {/* Web View */}
      <div className={`hidden md:flex justify-center gap-12  text-xs md:text-sm font-bold border-[1px] border-border-color rounded-[6px]`}>
        {reviewTabList.map((obj, i) => (
          <div key={i} onClick={() => setActiveTab(i)} className={`tab cursor-pointer py-5 flex flex-col items-center transition-all duration-300 ${activeTab === i && "border-b-2 border-black"}`}>
            <div className="flex items-center gap-2">
              <span>{obj}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewTabs;
